import React from 'react';
import { motion } from 'framer-motion';
import { Download, Sparkles, BatteryCharging } from 'lucide-react';
import './HowItWorksSection.css';

const steps = [
  {
    icon: <Download size={28} />,
    title: "1. Download the App",
    desc: "Install Relax on your Android device.",
  },
  {
    icon: <Sparkles size={28} />,
    title: "2. Choose Your Mood",
    desc: "Pick sounds or sessions based on how you feel.",
  },
  {
    icon: <BatteryCharging size={28} />,
    title: "3. Relax & Recharge",
    desc: "Enjoy calm moments daily and feel the difference.",
  }
];

const HowItWorksSection = () => {
  return (
    <section id="how-it-works" className="section-padding how-it-works-section">
      <div className="container">
        <motion.div 
          className="section-header text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2>How It <span className="text-primary">Works</span></h2>
          <p>Your journey to relaxation starts in three simple steps.</p>
        </motion.div>

        <div className="steps-container">
          {steps.map((step, index) => (
            <motion.div 
              key={index} 
              className="step-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
            >
              <div className="step-number-bg">{index + 1}</div>
              <div className="step-icon">{step.icon}</div>
              <h3>{step.title}</h3>
              <p>{step.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
